<li [class]="customClass" [class.has-children]="item.children.length > 0" [class.menu-item--expanded]="expanded">
  <a [routerLink]="getUrl()" (click)="onMenuItemClick()" [fragment]="getFragment()" [title]="item.title">{{ item.title }}</a>
  <ul *ngIf="item.children.length" class="menu-item--children">
    <ng-container *ngFor="let child of item.children">
      <app-menu-item [item]="child"></app-menu-item>
    </ng-container>
  </ul>
</li>
